import { createFileRoute } from "@tanstack/react-router";
import ElderCareProgramPage from "@project/user/pages/care/elder-care-program";

export const Route = createFileRoute("/_user/_care/elder-care-program")({
  head: () => ({
    meta: [
      { title: "Elder Care Program — Jivandhara" },
      {
        name: "description",
        content:
          "Lifetime shelter, daily care, medical attention and dignified companionship for elderly residents at Jivandhara.",
      },
      { property: "og:title", content: "Elder Care Program — Jivandhara" },
      { property: "og:image", content: careImg },
    ],
  }),
  component: ElderCareProgramPage,
});
